import * as types from "../dashboardActionTypes";

export default function systemStatusReducer(state = {}, action) {
    switch(action.type) {
        case types.LOAD_SYSTEM_STATUS_SUCCESS:
            return action.systemStatus;
        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/dashboard/reducers/systemStatusReducer.js